export default __webpack_public_path__ + "fcff2dda7a52d33db39bb320f4ddf7e8.png";